import { render, staticRenderFns } from "./EditMspsPaciente.vue?vue&type=template&id=52924a34"
import script from "./EditMspsPaciente.vue?vue&type=script&lang=js"
export * from "./EditMspsPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports